export default __webpack_public_path__ + "d80e0a7fb0cc9a0ef3a9dbccfae529fd.png";